/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Um Ihr Fahrzeug hinzuzufügen, müssen Sie ein Michelin-Konto haben.`
};

const en_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `To register your vehicle, you must have a Michelin account.`
};

const es_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Para añadir tu vehículo debes tener una cuenta Michelin.`
};

const fr_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Pour enregistrer votre véhicule, vous devez avoir un compte Michelin.`
};

const it_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Per aggiungere il tuo veicolo, devi avere un account Michelin.`
};

const nl_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Om uw voertuig toe te voegen, moet u een Michelin-account hebben.`
};

const pt_register_car__account_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Para adicionar o seu veículo, tem possuir uma conta Michelin.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_car__account_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_car__account_subtitle", locale)
	if (locale === "de") return de_register_car__account_subtitle(inputs)
	if (locale === "en") return en_register_car__account_subtitle(inputs)
	if (locale === "es") return es_register_car__account_subtitle(inputs)
	if (locale === "fr") return fr_register_car__account_subtitle(inputs)
	if (locale === "it") return it_register_car__account_subtitle(inputs)
	if (locale === "nl") return nl_register_car__account_subtitle(inputs)
	return pt_register_car__account_subtitle(inputs)
};